import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { MsalProvider } from "@azure/msal-react"
import { msalInstance, initializeAuth } from './auth/authService'
import { AuthProvider } from './contexts/AuthContext'
import { NavigationProvider } from './contexts/NavigationContext'
import { useState, useEffect } from 'react'
import AppLayout from './components/layout/AppLayout'
import Dashboard from './pages/Dashboard'
import Clients from './pages/Clients'
import ClientDetails from './pages/ClientDetails'
import Matters from './pages/Matters'
import MatterDetails from './pages/MatterDetails'
import Settings from './pages/Settings'
import Prototypes from './pages/Prototypes'
import SampleDataSeeding from './pages/SampleDataSeeding'
import MatterComponentsDemo from './pages/MatterComponentsDemo'
import AuthDebug from './pages/AuthDebug'
import ContainerTestPage from './pages/ContainerTestPage'
import SharePointEmbeddedTestPage from './components/debug/SharePointEmbeddedTestPage'
import { AdminRoute } from './components/auth/AdminRoute'
import { ToastProvider } from './components/ui/Toast'
import { apiClient } from './services/apiClient'

// GitHub Actions Deployment Test - July 20, 2025 - Testing SWA CLI Deployment Fix
function App() {
  const [isAuthInitialized, setIsAuthInitialized] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      try {
        await initializeAuth();
        
        // Warmup API to prevent cold start issues
        apiClient.warmupApi();
        
        setIsAuthInitialized(true);
      } catch (error) {
        console.error('[App] Auth initialization failed:', error);
        // Still set as initialized to allow the app to continue
        setIsAuthInitialized(true);
      }
    };

    initialize();
  }, []);

  if (!isAuthInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2"></div>
          <p className="text-gray-600">Initializing authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <NavigationProvider>
          <ToastProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<AppLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="clients" element={<Clients />} />
                  <Route path="clients/:id" element={<ClientDetails />} />
                  <Route path="matters" element={<Matters />} />
                  <Route path="matters/:id" element={<MatterDetails />} />
                  <Route path="settings" element={<AdminRoute><Settings /></AdminRoute>} />
                  <Route path="prototypes" element={<AdminRoute><Prototypes /></AdminRoute>} />
                  <Route path="admin/sample-data" element={<AdminRoute><SampleDataSeeding /></AdminRoute>} />
                  <Route path="demo" element={<AdminRoute><MatterComponentsDemo /></AdminRoute>} />
                  <Route path="debug/auth" element={<AdminRoute><AuthDebug /></AdminRoute>} />
                  <Route path="debug/container" element={<AdminRoute><ContainerTestPage /></AdminRoute>} />
                  <Route path="debug/spe" element={<AdminRoute><SharePointEmbeddedTestPage /></AdminRoute>} />
                </Route>
              </Routes>
            </BrowserRouter>
          </ToastProvider>
        </NavigationProvider>
      </AuthProvider>
    </MsalProvider>
  )
}

export default App
